import { render, staticRenderFns } from "./Padlock.vue?vue&type=template&id=588e32a1&"
import script from "./Padlock.vue?vue&type=script&lang=js&"
export * from "./Padlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports